import React, { useState, useEffect } from 'react';
import { 
  Wifi, 
  Bluetooth, 
  Sun, 
  Volume2, 
  ArrowUp, 
  Info, 
  MapPin, 
  Plane, 
  RotateCcw, 
  X,
  Bell,
  Camera,
  Flashlight,
  Calculator,
  ArrowRight
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const StaccatoDetail = () => {
  const [wifiEnabled, setWifiEnabled] = useState(true);
  const [bluetoothEnabled, setBluetoothEnabled] = useState(true);
  const [brightness, setBrightness] = useState(75);
  const [volume, setVolume] = useState(60);
  const [airplaneMode, setAirplaneMode] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  // Show notification after component mounts
  useEffect(() => {
    const timer = setTimeout(() => setShowNotification(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const ControlToggle = ({ icon: Icon, label, enabled, onToggle, color = "blue" }) => (
    <div className="bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-md border border-white/20">
      <button 
        onClick={onToggle}
        className={`w-full flex items-center justify-between transition-all duration-300 ${
          enabled ? 'opacity-100' : 'opacity-60'
        }`}
      >
        <div className="flex items-center space-x-2">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
            enabled 
              ? `bg-${color}-500 text-white shadow-md shadow-${color}-200` 
              : 'bg-gray-200 text-gray-400'
          }`}>
            <Icon className="w-3 h-3" />
          </div>
          <span className={`text-xs font-medium transition-colors duration-300  ${
            enabled ? 'text-gray-900' : 'text-gray-500'
          }`}>
            {label}
          </span>
        </div>
        <div className={`w-8 h-4 rounded-full transition-all duration-300 ${
          enabled ? `bg-${color}-500` : 'bg-gray-300'
        } relative`}>
          <div className={`w-3 h-3 bg-white rounded-full shadow-sm transition-all duration-300 absolute top-0.5 ${
            enabled ? 'translate-x-4' : 'translate-x-0.5'
          }`} />
        </div>
      </button>
    </div>
  );

  const SliderControl = ({ icon: Icon, label, value, onChange, color = "blue" }) => (
    <div className="bg-white/90 backdrop-blur-sm rounded-xl p-3 shadow-md border border-white/20">
      <div className="flex items-center space-x-2 mb-2">
        <div className={`w-6 h-6 rounded-full bg-${color}-500 flex items-center justify-center text-white shadow-md shadow-${color}-200`}>
          <Icon className="w-3 h-3" />
        </div>
        <span className="text-xs font-medium text-gray-900">{label}</span>
      </div>
      <div className="relative">
        <input
          type="range"
          min="0"
          max="100"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          className={`w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer slider-${color}`}
        />
        <div className={`absolute right-1 top-2 text-xs font-medium text-${color}-600`}>
          {value}%
        </div>
      </div>
    </div>
  );

  const QuickAction = ({ icon: Icon, label, color = "gray" }) => (
    <button className="bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-md border border-white/20 flex flex-col items-center justify-center space-y-1 hover:scale-105 transition-all duration-300 hover:shadow-lg">
      <div className={`w-6 h-6 rounded-full bg-${color}-500 flex items-center justify-center text-white shadow-md shadow-${color}-200`}>
        <Icon className="w-3 h-3" />
      </div>
      {/* <span className="text-xs font-medium text-gray-700">{label}</span> */}
    </button>
  );

//   const PushNotification = () => (
//     <div className={`fixed top-4 left-4 right-4 z-50 transform transition-all duration-700 ${
//       showNotification ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
//     }`}>
//       <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 mx-auto max-w-sm">
//         <div className="flex items-start space-x-3">
//           <div className="flex-shrink-0">
//             <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
//               <Bell className="w-4 h-4 text-white" />
//             </div>
//           </div>
//           <div className="flex-1 min-w-0">
//             <div className="flex items-center justify-between mb-1">
//               <p className="text-sm font-semibold text-gray-900">Staccato</p>
//               <p className="text-xs text-gray-500">now</p>
//             </div>
//             <p className="text-sm text-gray-800 font-medium mb-1">Your Last Chance to Shop</p>
//             <p className="text-xs text-gray-600">Visit Staccato stores nearest you now.</p>
//           </div>
//           <button 
//             onClick={() => setShowNotification(false)}
//             className="flex-shrink-0 text-gray-400 hover:text-gray-600"
//           >
//             <X className="w-4 h-4" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

  const AdBanner = () => (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="relative">
        {/* Ad Label */}
        {/* <div className="absolute top-3 left-3 bg-black/80 text-white px-2 py-1 rounded text-xs font-medium z-10">
          AD
        </div> */}
        
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
  <img
    src="/assets/stacctao.png"
    alt="Fashion model in stylish outfit"
    className="w-full h-full object-cover"
  />
</div>
        
      
        
      </div>
    </div>
  );

  return (
    <>
     <Helmet>
       <title>
         Staccato Brand | Push Notification Campaign Showcase
        </title>
        <meta
          name="description"
          content="See how Staccato brand uses Push Notification ads with Bidbox. Explore engaging campaigns that capture attention & drive instant user action."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/push-notification/staccato"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-16">
      {/* Push Notification */}
      {/* <PushNotification /> */}

      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-10">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Be Seen in the Moment
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Push Notification
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                DELIVER INSTANT UPDATES
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                Push Notifications put Staccato right on the viewer’s device screen—driving action the second it matters. Whether it’s a flash sale, new arrival, or time-limited offer, your message appears instantly, prompting immediate engagement. It’s direct, personal, and impossible to miss. Craft a short, compelling line, add your call-to-action, and watch your audience tap through in real time.
  </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                                 <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                                   <span>Start with this Template</span>
                                   <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                                 </button>
                                 </Link>
              </div>
            </div>
          </div>

          {/* Right column - iPhone Mockup */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              {/* iPhone mockup */}
              <div className="mx-auto max-w-xs relative">
                {/* iPhone Frame */}
                <div className="bg-black rounded-[2.5rem] p-2 shadow-2xl">
                  <div className="bg-whie rounded-[2rem] overflow-hidden relative">
                    
                    {/* Status Bar */}
                    <div className="bg-white px-4 py-2 flex justify-between items-center text-black text-sm font-medium">
                      <span>9:41</span>
                      <div className="flex items-center space-x-1">
                        <div className="flex space-x-1">
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                        </div>
                        <div className="w-6 h-3 border border-black rounded-sm relative ml-1">
                          <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                        </div>
                      </div>
                    </div>

                    {/* Control Center Content */}
                    <div className="p-3 bg-gray-50 h-[500px] overflow-hidden">
                      
                      {/* Main Controls Grid */}
                      <div className="grid grid-cols-2 gap-2 mb-4">
                        <ControlToggle
                          icon={Wifi}
                          label="Wi-Fi"
                          enabled={wifiEnabled}
                          onToggle={() => setWifiEnabled(!wifiEnabled)}
                          color="blue"
                        />
                        <ControlToggle
                          icon={Bluetooth}
                          label="Bluetooth"
                          enabled={bluetoothEnabled}
                          onToggle={() => setBluetoothEnabled(!bluetoothEnabled)}
                          color="blue"
                        />
                      </div>

                   

                      {/* Quick Actions Grid */}
                      <div className="grid grid-cols-4 gap-2 mb-4">
                        <QuickAction icon={ArrowUp} label="AirDrop" color="blue" />
                        <QuickAction icon={Info} label="Info" color="gray" />
                        <QuickAction icon={MapPin} label="Location" color="red" />
                        <QuickAction 
                          icon={Plane} 
                          label="Airplane" 
                          color={airplaneMode ? "orange" : "gray"}
                        />
                      </div>

                      {/* Ad Banner */}
                      <AdBanner />
                    </div>

                    {/* Bottom Indicator */}
                    <div className="h-1 bg-black rounded-full w-24 mx-auto mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .slider-blue::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #3b82f6;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(59, 130, 246, 0.3);
        }
        
        .slider-yellow::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #eab308;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(234, 179, 8, 0.3);
        }
        
        .slider-green::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #22c55e;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>

       <div className="max-w-7xl mx-auto px-4 py-10">
                    <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
              
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                      {/* Card 1 */}
                      <Link to="/ctv-carousel-l-band/lenovo" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/Lenovo.avif"
                          alt="Card 1"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Lenovo</h2>
                        </div>
                      </Link>
              
                      {/* Card 2 */}
                      <Link to="/dynamic-calculator/zakat" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/zakat.webp"
                          alt="Card 2"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Zakat Calculator</h2>
                        </div>
                      </Link>
              
                      {/* Card 3 */}
                      <Link to="/interactive-selector/donation" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/donation.png "
                          alt="Card 3"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Donation</h2>
                        </div>
                      </Link>
              
                      {/* Card 4 */}
                      <Link to="/spin-the-wheel/mamaearth" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/mam1.jpg"
                          alt="Card 4"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Mama Earth</h2>
                        </div>
                      </Link>
              
                     
                    </div>
                  </div>
    </>
  );
};

export default StaccatoDetail;

